import { render, staticRenderFns } from "./AuthCheck.vue?vue&type=template&id=6b90a0ba&"
import script from "./AuthCheck.vue?vue&type=script&lang=js&"
export * from "./AuthCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b90a0ba')) {
      api.createRecord('6b90a0ba', component.options)
    } else {
      api.reload('6b90a0ba', component.options)
    }
    module.hot.accept("./AuthCheck.vue?vue&type=template&id=6b90a0ba&", function () {
      api.rerender('6b90a0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/auth/screens/AuthCheck.vue"
export default component.exports